import {Button} from "@material-ui/core";
import {buttonsStyle} from "./styles";

export const CloseBill = ({handleCLick, text, width, right, resetStyles = {}}) => {
    const classes = buttonsStyle()
    return (
        <div className={classes.closeBill}>
            <Button
                style={{width:width, marginRight:right, ...resetStyles}}
                onClick={handleCLick}>
                {text}
            </Button>
        </div>
    )
}